import { getBrowserZipcode } from './akamaiFunctions';
import { authUtilityModuleUrl } from '../constants/config';

export function getCookie(name) {
  function escape(s) {
  // eslint-disable-next-line
  const escapeReturn = s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
    return escapeReturn;
  }
  let match;

  if (typeof window !== 'undefined' && typeof window?.document !== 'undefined') {
  // eslint-disable-next-line
    match = window?.document?.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
  }
  return match ? match[1] : null;
}

export function getLocalStorage(name) {
  let match;
  if (typeof window !== 'undefined') {
    match = window?.localStorage.getItem(name);
  }
  return match?.toString('ascii');
}

const isSignedIn = async () => {
  let loggedIn = '0';
  const { getIsUserSignedIn } = await import(/* webpackIgnore: true */ authUtilityModuleUrl);
  const signedIn = await getIsUserSignedIn();
  if (typeof window !== 'undefined') {
    window?.localStorage.setItem('isUserSignedIn', signedIn);
  }
  if (signedIn) {
    loggedIn = '1';
  }

  return loggedIn;
};

export async function getDataLayerData() {
  const zip = getBrowserZipcode();
  const pxaId = getCookie('pxa_id');
  const pxaIdBackup = getCookie('pxa_id_backup');
  const abc = getCookie('abc');
  const pxaRealId = getCookie('pxa_realid');
  const pixallAbc = getCookie('pixall_abc');
  let isLoggedIn;

  if (typeof window !== 'undefined' && typeof window?.document !== 'undefined') {
    isLoggedIn = await isSignedIn();
  }

  return {
    zip,
    pxaId,
    pxaIdBackup,
    abc,
    pxaRealId,
    pixallAbc,
    isLoggedIn,
  };
}

export function getSignedInStatus() {
  let status = false;
  if (typeof window !== 'undefined') {
    status = window?.isUserSignedIn || window?.localStorage.getItem('isUserSignedIn');
  }

  return status;
}
